
import {cnpj, Schema} from 'simpli-web-sdk'
import DeliveryDriverResponse from '@/model/response/DeliveryDriverResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'
import DeliveryAuditResponse from '@/model/response/DeliveryAuditResponse'

export default (model: DeliveryAuditResponse): Schema => ({
    nome: {
        content: model.nome,
    },

    documento: {
        content: cnpj(model.documento),
    },

    checkinConforme: {
        content: {
            component: RenderNumber,
            props: {
                number: model.checkinConforme,
            },
        },
        textContent: model.checkinConforme || '0',
    },

    checkinNaoConforme: {
        content: {
            component: RenderNumber,
            props: {
                number: model.checkinNaoConforme,
            },
        },
        textContent: model.checkinNaoConforme || '0',
    },

    checkinNaoInformado: {
        content: {
            component: RenderNumber,
            props: {
                number: model.checkinNaoInformado,
            },
        },
        textContent: model.checkinNaoInformado || '0',
    },

    entregaConforme: {
        content: {
            component: RenderNumber,
            props: {
                number: model.entregaConforme,
            },
        },
        textContent: model.entregaConforme || '0',
    },

    entregaNaoConforme: {
        content: {
            component: RenderNumber,
            props: {
                number: model.entregaNaoConforme,
            },
        },
        textContent: model.entregaNaoConforme || '0',
    },

    entregaNaoInformado: {
        content: {
          component: RenderNumber,
          props: {
            number: model.entregaNaoInformado,
          },
        },
        textContent: model.entregaNaoInformado || '0',
    },
})
